import { render, staticRenderFns } from "./DoorDamageSeverity.vue?vue&type=template&id=252e8374&scoped=true"
import script from "./DoorDamageSeverity.vue?vue&type=script&lang=ts"
export * from "./DoorDamageSeverity.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252e8374",
  null
  
)

export default component.exports